// Generated at staging build time. Do not add server secrets here.
export const environment = {
  "name": "staging",
  "production": false,
  "supabaseUrl": "https://bpkcculqwzstvarakylw.supabase.co",
  "supabasePublishableKey": "sb_publishable_sSnSg_mREEoxdI-M4fnnmg_QyrI1QqU"
} as const;
